module.exports = __webpack_public_path__ + "static/media/014.2f1d78f8.jpg";